function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_48",
  x1: 375.47,
  y1: 490.79,
  x2: 375.47,
  y2: 123.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#fff",
  stopOpacity: 0.57
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#fff",
  stopOpacity: 0.33
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#fff",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#fff",
  stopOpacity: 0.04
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#fff",
  stopOpacity: 0
}));

var _ref3 = /*#__PURE__*/React.createElement("image", {
  id: "Layer_1_Image",
  "data-name": "Layer 1\\xA0Image",
  width: 417,
  height: 447,
  transform: "translate(315.43 314.27) scale(0.05)",
  xlinkHref: "data:image/png;base64,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"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 343.85,
  cy: 177.2,
  r: 6.57
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 405.7,
  cy: 176.41,
  r: 6.57
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 373.4,
  cy: 419.57,
  rx: 32.92,
  ry: 32.61
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M388.31,161.46c-3.87,1.28-8.44,3.09-12.33,3.09s-8.46-1.81-12.34-3.09c-10.44-3.44-36.78-5.67-53.45-.33l.5,9.22a3.47,3.47,0,0,1,4,2.67c1,3.33,3.32,17.08,7.57,22.45,5.27,6.67,16.63,6.92,24.31,6.59,10.34-.44,17.12-5,20-12.82s4.52-14.44,6.37-16.55a4.27,4.27,0,0,1,6,0c1.85,2.11,3.48,8.78,6.37,16.55s9.66,12.38,20,12.82c7.69.33,19,.08,24.32-6.59,4.25-5.37,6.57-19.12,7.57-22.45a3.47,3.47,0,0,1,4-2.67l.5-9.22C425.1,155.79,398.76,158,388.31,161.46Zm-75.05,4c0-.65,1.68-1.18,3.74-1.18s3.75.53,3.75,1.18-1.68,1.19-3.75,1.19S313.26,166.12,313.26,165.46ZM362,189.24c-2.78,5.23-7.45,7.89-14.45,8.78s-15.37-.48-19.6-3c-3.71-2.21-5.52-9.22-6.41-13.44s-2.44-13.34,1.89-16.34,15.23-3.22,22.45-2.78c5.45.34,17.23,1.78,19.45,6S364.22,185,362,189.24Zm68.45-7.66c-.89,4.22-2.69,11.23-6.41,13.44-4.22,2.52-12.59,3.89-19.59,3s-11.67-3.55-14.45-8.78c-2.25-4.22-5.56-16.55-3.33-20.78s14-5.66,19.44-6c7.22-.44,18.12-.22,22.45,2.78S431.32,177.35,430.43,181.58ZM435,166.65c-2.06,0-3.74-.53-3.74-1.19s1.68-1.18,3.74-1.18,3.74.53,3.74,1.18S437,166.65,435,166.65Z"
});

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 723.89,
    height: 513.88,
    viewBox: "0 0 723.89 513.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.93,162.32c-7.21-.44-18.11-.22-22.45,2.78s-2.77,12.11-1.88,16.33,2.69,11.24,6.4,13.45c4.23,2.52,12.6,3.89,19.6,3s11.67-3.56,14.45-8.78c2.25-4.23,5.55-16.56,3.33-20.78S351.38,162.65,345.93,162.32Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.21,
    y: 284.85,
    width: 161.69,
    height: 150.92,
    style: {
      stroke: "#39ff14",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.21,
    y: 284.85,
    width: 161.69,
    height: 15.96,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "code-line1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.38,
    y: 313.94,
    width: 22.9,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.26,
    y: 313.94,
    width: 22.9,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.47,
    y: 338.18,
    width: 35.51,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.85,
    y: 338.18,
    width: 18.05,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 613.79,
    y: 362.42,
    width: 15.6,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.4,
    y: 362.42,
    width: 51.74,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.9,
    y: 386.66,
    width: 59.13,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.12,
    y: 410.9,
    width: 18.2,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-line9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.1,
    y: 410.9,
    width: 18.2,
    height: 4.5,
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 575.97,
    y: 313.8,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43,404.2H576v-5h2.46Zm0-12.56H576v-5h2.46Zm0-12.56H576v-5h2.46Zm0-12.57H576v-5h2.46Zm0-12.56H576v-5h2.46Zm0-12.56H576v-5h2.46Zm0-12.56H576v-5h2.46Z",
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.97,
    y: 411.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.77,
    y: 0.16,
    width: 233.69,
    height: 218.29,
    style: {
      stroke: "#39ff14",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.77,
    y: 0.16,
    width: 233.69,
    height: 15.04,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,218.45c0-1.15-.06-87.1-.14-218.29l.14.13L11.79.32h0l.16-.16c0,79.63,0,154.44,0,218.29l-.14-.14,233.69.14-233.69.14h-.14v-.14c0-63.85,0-138.66,0-218.29V0h.18L245.46,0h.13V.16C245.51,131.35,245.46,217.3,245.46,218.45Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S44.4,77.43,44.4,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S40.75,77.43,40.75,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S37.1,77.43,37.1,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.45,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S33.45,77.43,33.45,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S29.8,77.43,29.8,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.15,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S26.15,77.43,26.15,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S22.5,77.43,22.5,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.85,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S18.85,77.43,18.85,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,77.34c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S15.2,77.43,15.2,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55,77.34c0-.09.41-.16.91-.16s.92.07.92.16-.41.16-.92.16S11.55,77.43,11.55,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,77.34c0-.09.41-.16.91-.16s.92.07.92.16-.41.16-.92.16S7.9,77.43,7.9,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25,77.34c0-.09.41-.16.91-.16s.92.07.92.16-.41.16-.92.16S4.25,77.43,4.25,77.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,76.29c.09,0,.16.41.16.91v.14l-.16-.16c.44,0,.78.08.78.16s-.34.14-.78.16H1.5v-.3C1.49,76.7,1.56,76.29,1.65,76.29Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,72.64c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S1.56,72.64,1.65,72.64Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,69c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S1.56,69,1.65,69Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,65.34c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S1.56,65.34,1.65,65.34Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,61.69c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S1.56,61.69,1.65,61.69Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,58c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S1.56,58,1.65,58Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,54.39c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S1.56,54.39,1.65,54.39Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,50.74c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S1.56,50.74,1.65,50.74Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,47.09c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S1.56,47.09,1.65,47.09Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,43.44c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S1.56,43.44,1.65,43.44Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,39.79c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S1.56,39.79,1.65,39.79Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65,36.14c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S1.56,36.14,1.65,36.14Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92,32.77s-.1.08-.27.11l.11-.11a3.69,3.69,0,0,1,.05.64c0,.5-.07.91-.16.91s-.16-.41-.16-.91a3.69,3.69,0,0,1,.05-.64l0-.13.09,0C1.82,32.68,1.92,32.72,1.92,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.41-.16.91-.16S5.57,32.68,5.57,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.41-.16.91-.16S9.22,32.68,9.22,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.41-.16.91-.16S12.87,32.68,12.87,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.52,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.41-.16.91-.16S16.52,32.68,16.52,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.41-.16.91-.16S20.17,32.68,20.17,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.41-.16.91-.16S23.82,32.68,23.82,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.47,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.4-.16.91-.16S27.47,32.68,27.47,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.12,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.4-.16.91-.16S31.12,32.68,31.12,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.4-.16.91-.16S34.77,32.68,34.77,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.42,32.77c0,.09-.41.16-.91.16s-.91-.07-.91-.16.4-.16.91-.16S38.42,32.68,38.42,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.07,32.77c0,.09-.41.16-.91.16s-.92-.07-.92-.16.41-.16.92-.16S42.07,32.68,42.07,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,32.77c0,.09-.41.16-.91.16s-.92-.07-.92-.16.41-.16.92-.16S45.72,32.68,45.72,32.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,35.92c-.09,0-.16-.41-.16-.92s.07-.91.16-.91.16.41.16.91S46.31,35.92,46.22,35.92Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,39.57c-.09,0-.16-.41-.16-.92s.07-.91.16-.91.16.41.16.91S46.31,39.57,46.22,39.57Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,43.21c-.09,0-.16-.4-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,43.21,46.22,43.21Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,46.86c-.09,0-.16-.4-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,46.86,46.22,46.86Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,50.51c-.09,0-.16-.4-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,50.51,46.22,50.51Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,54.16c-.09,0-.16-.4-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,54.16,46.22,54.16Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,57.81c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,57.81,46.22,57.81Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,61.46c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,61.46,46.22,61.46Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,65.11c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,65.11,46.22,65.11Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,68.76c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,68.76,46.22,68.76Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,72.41c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S46.31,72.41,46.22,72.41Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,76.06c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.4.16.91S46.31,76.06,46.22,76.06Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.57,
    y: 75.24,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 75.69,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.57,
    y: 30.8,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 31.12,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.11,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S46.11,227,46.11,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.46,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S42.46,227,42.46,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.81,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S38.81,227,38.81,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.16,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S35.16,227,35.16,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.41.16-.91.16S31.51,227,31.51,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.86,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S27.86,227,27.86,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S24.21,227,24.21,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.56,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S20.56,227,20.56,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.91,226.9c0-.09.41-.16.91-.16s.91.07.91.16-.4.16-.91.16S16.91,227,16.91,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.26,226.9c0-.09.41-.16.91-.16s.92.07.92.16-.41.16-.92.16S13.26,227,13.26,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61,226.9c0-.09.41-.16.91-.16s.92.07.92.16-.41.16-.92.16S9.61,227,9.61,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,226.9c0-.09.41-.16.91-.16s.92.07.92.16-.41.16-.92.16S6,227,6,226.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,225.85c.09,0,.16.41.16.91v.14l-.16-.16c.44,0,.78.08.78.16s-.34.14-.78.15H3.21v-.3C3.2,226.26,3.27,225.85,3.36,225.85Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,222.2c.09,0,.16.41.16.91s-.07.91-.16.91-.16-.4-.16-.91S3.27,222.2,3.36,222.2Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,218.55c.09,0,.16.41.16.91s-.07.91-.16.91-.16-.4-.16-.91S3.27,218.55,3.36,218.55Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,214.9c.09,0,.16.41.16.91s-.07.91-.16.91-.16-.4-.16-.91S3.27,214.9,3.36,214.9Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,211.25c.09,0,.16.41.16.91s-.07.91-.16.91-.16-.4-.16-.91S3.27,211.25,3.36,211.25Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,207.6c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S3.27,207.6,3.36,207.6Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,204c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S3.27,204,3.36,204Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,200.3c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S3.27,200.3,3.36,200.3Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,196.65c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S3.27,196.65,3.36,196.65Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,193c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S3.27,193,3.36,193Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,189.35c.09,0,.16.41.16.91s-.07.92-.16.92-.16-.41-.16-.92S3.27,189.35,3.36,189.35Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,185.7c.09,0,.16.41.16.92s-.07.91-.16.91-.16-.41-.16-.91S3.27,185.7,3.36,185.7Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63,182.33s-.1.08-.27.11l.11-.11a3.69,3.69,0,0,1,0,.64c0,.5-.07.91-.16.91s-.16-.41-.16-.91a3.69,3.69,0,0,1,0-.64l0-.13h.09C3.53,182.24,3.63,182.28,3.63,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28,182.33c0,.08-.4.15-.91.15s-.91-.07-.91-.15.41-.16.91-.16S7.28,182.24,7.28,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.93,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.41-.16.91-.16S10.93,182.24,10.93,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.58,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.41-.16.91-.16S14.58,182.24,14.58,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.41-.16.91-.16S18.23,182.24,18.23,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.41-.16.91-.16S21.88,182.24,21.88,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.53,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.41-.16.91-.16S25.53,182.24,25.53,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.18,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.4-.16.91-.16S29.18,182.24,29.18,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.83,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.4-.16.91-.16S32.83,182.24,32.83,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.48,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.4-.16.91-.16S36.48,182.24,36.48,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.13,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.4-.16.91-.16S40.13,182.24,40.13,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.78,182.33c0,.08-.41.15-.91.15s-.91-.07-.91-.15.4-.16.91-.16S43.78,182.24,43.78,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.43,182.33c0,.08-.41.15-.91.15s-.92-.07-.92-.15.41-.16.92-.16S47.43,182.24,47.43,182.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,185.47c-.09,0-.16-.4-.16-.91s.07-.91.16-.91.16.41.16.91S48,185.47,47.93,185.47Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,189.12c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S48,189.12,47.93,189.12Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,192.77c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S48,192.77,47.93,192.77Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,196.42c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S48,196.42,47.93,196.42Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,200.07c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S48,200.07,47.93,200.07Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,203.72c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S48,203.72,47.93,203.72Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,207.37c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.41.16.91S48,207.37,47.93,207.37Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,211c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.4.16.91S48,211,47.93,211Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,214.67c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.4.16.91S48,214.67,47.93,214.67Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,218.32c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.4.16.91S48,218.32,47.93,218.32Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,222c-.09,0-.16-.41-.16-.91s.07-.91.16-.91.16.4.16.91S48,222,47.93,222Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,225.62c-.09,0-.16-.41-.16-.91s.07-.92.16-.92.16.41.16.92S48,225.62,47.93,225.62Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.28,
    y: 224.8,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.71,
    y: 225.25,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.28,
    y: 180.35,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.71,
    y: 180.68,
    width: 3.3,
    height: 3.3,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.28,80.15a3.17,3.17,0,0,1-3.06,3.18A3,3,0,0,1,156,80.47,3.16,3.16,0,0,1,159,77.29,3,3,0,0,1,162.28,80.15Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,76.63c-.39.41-2.78-1.37-6.18-1.37S155.33,77,155,76.53c-.18-.19.22-.93,1.31-1.72a8.74,8.74,0,0,1,5-1.53,8.34,8.34,0,0,1,4.92,1.61C167.25,75.7,167.61,76.44,167.41,76.63Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,80.63a3.16,3.16,0,0,1-3.06,3.18A3,3,0,0,1,121.15,81a3.15,3.15,0,0,1,3-3.18A3,3,0,0,1,127.46,80.63Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92,77.75c-.39.41-2.79-1.37-6.18-1.38s-5.9,1.69-6.27,1.28c-.18-.19.22-.93,1.31-1.72a8.74,8.74,0,0,1,5-1.53A8.34,8.34,0,0,1,130.72,76C131.76,76.82,132.11,77.56,131.92,77.75Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,103c0-.19,2.1-.55,5.53-1,.86-.08,1.69-.25,1.84-.85a4.46,4.46,0,0,0-.58-2.57c-.8-2.11-1.65-4.31-2.54-6.63-3.54-9.42-6.09-17.17-5.71-17.31s3.55,7.39,7.09,16.81q1.27,3.49,2.44,6.67a5.1,5.1,0,0,1,.44,3.41,2.21,2.21,0,0,1-1.44,1.26,5.54,5.54,0,0,1-1.47.2C146.33,103.2,144.19,103.2,144.18,103Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,105.33c.55,0,.55,3.66,3.7,6.29s7.08,2.24,7.11,2.76c.05.23-.88.71-2.54.75a9.21,9.21,0,0,1-5.94-2.09,8,8,0,0,1-2.86-5.28C133.49,106.22,133.91,105.31,134.16,105.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8,66.71c-.35.85-3.1.5-6.32.78s-5.89,1-6.36.18c-.21-.38.25-1.12,1.34-1.86a10.67,10.67,0,0,1,9.74-.74C128.38,65.64,129,66.3,128.8,66.71Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.84,67.63c-.35.85-3.1.5-6.32.78s-5.89,1-6.36.18c-.21-.38.25-1.12,1.34-1.86a10.67,10.67,0,0,1,9.74-.74C164.42,66.56,165,67.22,164.84,67.63Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.26,
    y: 197.29,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.94,
    y: 172.85,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.02,
    y: 171.93,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.57,
    y: 141.44,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.76,
    y: 127.94,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.81,
    y: 125.59,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.75,
    y: 58.11,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.41,
    y: 45.24,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.36,
    y: 57.98,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.6,
    y: 57.48,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.78,
    y: 28.31,
    width: 3.66,
    height: 3.66,
    transform: "translate(56.71 -98.66) rotate(39.27)",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.69,
    y: 94.42,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.62,
    y: 58.57,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.14,
    y: 33.78,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.39,
    y: 27.16,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.3,
    y: 18.74,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 51.72,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.52,
    y: 62.22,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.72,
    y: 79.18,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.02,
    y: 91.89,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.95,
    y: 71.9,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.25,
    y: 113.31,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.04,
    y: 133.42,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.8,
    y: 103.5,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.19,
    y: 69.67,
    width: 3.66,
    height: 3.66,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.91,199.66c0,.18-7.08.32-15.82.32s-15.83-.14-15.83-.32,7.09-.33,15.83-.33S132.91,199.48,132.91,199.66Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.45,
    cy: 199.71,
    r: 0.97,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.88,
    cy: 199.71,
    r: 0.97,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,19.21c.12-.13,5.45,4.54,11.9,10.44s11.59,10.78,11.47,10.91S173.35,36,166.89,30.13,155.31,19.35,155.43,19.21Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,18.83a1,1,0,0,1,1.44,1.32,1,1,0,1,1-1.44-1.32Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,40.13a1,1,0,0,1,1.37-.07,1,1,0,1,1-1.37.07Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.57,106.54c.18,0,.33,3.54.33,7.91s-.15,7.92-.33,7.92-.32-3.55-.32-7.92S170.39,106.54,170.57,106.54Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.62,121.78a1,1,0,1,1-1,1A1,1,0,0,1,170.62,121.78Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.52,74.27c-.15-.09,1.49-3.23,3.68-7s4.07-6.78,4.23-6.69-1.49,3.23-3.67,7S61.68,74.36,61.52,74.27Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.09,61a1,1,0,1,1,1.33-.35A1,1,0,0,1,69.09,61Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 186.29,
    width: 17.31,
    height: 17.31,
    style: {
      fill: "#186009"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.06,
    y: 186.29,
    width: 17.31,
    height: 17.31,
    style: {
      fill: "#2fd30d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.12,
    y: 186.29,
    width: 17.31,
    height: 17.31,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.12,
    y: 186.29,
    width: 17.31,
    height: 17.31,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 186.29,
    width: 17.31,
    height: 17.31,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "pen-path",
    d: "M171,71.5s.05.13.09.39.08.7.13,1.18c.11,1,.24,2.56.35,4.56.23,4,.39,9.8.13,17.12-.16,3.66-.41,7.69-.85,12a101.14,101.14,0,0,1-2.26,13.9,35,35,0,0,1-7.33,14.06,28,28,0,0,1-14.79,9l.43-.49c-.08,5.44-.16,11.11-.24,17q-.07,4.38-.13,8.89c0,1.5-.06,3-.08,4.53l-.14,2.33-.39,2.31a27.06,27.06,0,0,1-14.54,18.25,29.6,29.6,0,0,1-21.81,1.76,26.3,26.3,0,0,1-15.36-12.48,24.3,24.3,0,0,1-2.71-8.73c-.25-3-.13-5.7-.18-8.37,0-10.56-.07-19.14-.09-25.15,0-2.91,0-5.2,0-6.84,0-.73,0-1.32,0-1.78a2.92,2.92,0,0,1,0-.61,2.45,2.45,0,0,1,.06.61c0,.46,0,1,.07,1.78q.06,2.46.17,6.83c.11,6,.25,14.59.43,25.15.08,2.64,0,5.47.24,8.29A23.57,23.57,0,0,0,95,185.4a25.37,25.37,0,0,0,14.86,12,28.57,28.57,0,0,0,21-1.76,26,26,0,0,0,14-17.52c.69-2.92.49-6,.59-9s.1-6,.14-8.9c.1-5.85.19-11.52.28-17v-.4l.42-.09a27.24,27.24,0,0,0,14.24-8.65,34.19,34.19,0,0,0,7.2-13.65,100.83,100.83,0,0,0,2.34-13.76c.48-4.32.78-8.33,1-12,.36-7.29.3-13.1.18-17.08q-.12-2.9-.18-4.56A13.39,13.39,0,0,1,171,71.5Zm27.7,36.36a30.28,30.28,0,0,1,1-5.8c.49-2.28,1.48-4.86,1.39-8A7.58,7.58,0,0,0,199,89.64a25.4,25.4,0,0,0-4.15-3.39,21.79,21.79,0,0,1-4.34-3.73,8.35,8.35,0,0,1-1.41-2.61,11.12,11.12,0,0,1-.41-3.08c0-2.13.43-4.34.61-6.69s0-5-1.71-7-4.17-3-6.3-4.38a21.65,21.65,0,0,1-5.71-5.4l.07.24a62.33,62.33,0,0,0,.17-9.7,15.77,15.77,0,0,0-4.09-9.37,46.34,46.34,0,0,0-8.05-7.11,34.58,34.58,0,0,0-10.25-4.55A70.82,70.82,0,0,0,142,21a110.68,110.68,0,0,0-12-.49,49.51,49.51,0,0,0-12.41,1.47A20.83,20.83,0,0,0,107,29.31l.61-.16a20.33,20.33,0,0,0-11.67-1.56,19.22,19.22,0,0,0-10.68,5.54,20,20,0,0,0-5.57,10.94c-.71,4.12-.52,8.3-1.37,12.3a13.82,13.82,0,0,1-2.41,5.5,17.8,17.8,0,0,1-4.68,3.95C69.44,67,67.56,68,65.82,69.34a11.43,11.43,0,0,0-4,5.32,15.34,15.34,0,0,0-.36,6.66c.28,2.18.76,4.31,1,6.45A13.84,13.84,0,0,1,62,94a16.77,16.77,0,0,1-3.5,5.32c-2.14,2.37-4.55,4.78-5.9,7.86a24.09,24.09,0,0,0-2,9.57c-.1,6.55,1.91,12.73,3.81,18.64l.09.28.28.07a34.12,34.12,0,0,0,12.89,1.4,11.11,11.11,0,0,0,6-2.51,9.32,9.32,0,0,0,2.78-5.88l-1,0a12.15,12.15,0,0,0,3.75,6c1.83,1.72,4.28,2.17,6.53,2.43a12.75,12.75,0,0,0,6.77-1,10.32,10.32,0,0,0,4.82-4.79l-1-.15a6.38,6.38,0,0,0,3.24,4.38,8.73,8.73,0,0,0,5.26.79,5.78,5.78,0,0,0,4.25-3.12,10,10,0,0,0,1-5.07v0c.22-15.86.42-30.81.61-44.64q.13-10.38.26-19.89c.08-3.17-.1-6.28.57-9.16a13.71,13.71,0,0,1,4-7.42l-.55-.07a34,34,0,0,0,16.13,13l0,0h.06l18.54.06h3.89c1.25,0,2.44-.15,3.58-.22l6.24-.46-.16-.08,5.79,9.14c.63,1,1.11,1.71,1.44,2.24s.5.72.5.72-.12-.26-.42-.77l-1.37-2.28-5.65-9.23,0-.08h-.1l-6.24.39c-1.14,0-2.33.18-3.57.19l-3.88,0-18.54-.19.11,0A33.31,33.31,0,0,1,115.56,46.7l-.23-.35-.32.28a14.47,14.47,0,0,0-4.27,7.78c-.71,3-.53,6.17-.62,9.31q-.16,9.51-.34,19.89c-.22,13.84-.46,28.78-.72,44.64v0a8.86,8.86,0,0,1-.87,4.55,4.71,4.71,0,0,1-3.54,2.59,7.67,7.67,0,0,1-4.62-.69,5.39,5.39,0,0,1-2.71-3.63l-.3-1.48L96.37,131A9.32,9.32,0,0,1,92,135.27a11.65,11.65,0,0,1-6.24.93c-2.13-.23-4.41-.71-5.92-2.17a11.29,11.29,0,0,1-3.42-5.41l-.66-3-.37,3.05A8.26,8.26,0,0,1,73,133.87a10.09,10.09,0,0,1-5.48,2.24A33.32,33.32,0,0,1,55,134.74l.37.35c-1.9-5.92-3.86-12-3.75-18.3a23,23,0,0,1,1.94-9.14c1.26-2.89,3.53-5.16,5.73-7.6A17.78,17.78,0,0,0,63,94.38a14.71,14.71,0,0,0,.54-6.73C63.05,83.29,61.6,79,62.85,75a10.2,10.2,0,0,1,3.64-4.81c1.64-1.29,3.49-2.32,5.3-3.47a18.86,18.86,0,0,0,4.94-4.2,14.8,14.8,0,0,0,2.6-5.92c.88-4.19.68-8.38,1.37-12.35A18.83,18.83,0,0,1,86,33.86a18.18,18.18,0,0,1,10.11-5.27,19.25,19.25,0,0,1,11.08,1.47l.38.17.24-.33a19.81,19.81,0,0,1,10-7,48.52,48.52,0,0,1,12.14-1.45,109.18,109.18,0,0,1,11.93.46A69,69,0,0,1,153.2,23.7a33.06,33.06,0,0,1,10,4.4A45.67,45.67,0,0,1,171.13,35,15.09,15.09,0,0,1,175.06,44a63.64,63.64,0,0,1-.13,9.58v.13l.08.11a22.41,22.41,0,0,0,5.92,5.55c2.22,1.42,4.64,2.38,6.17,4.21s1.75,4.32,1.6,6.57-.58,4.52-.57,6.74a11.38,11.38,0,0,0,.46,3.24,8.73,8.73,0,0,0,1.52,2.78,22.07,22.07,0,0,0,4.47,3.79,24.73,24.73,0,0,1,4.11,3.3,7.08,7.08,0,0,1,2,4.14c.13,3-.81,5.62-1.28,7.9a28.94,28.94,0,0,0-.9,5.86,11.15,11.15,0,0,0,.45,3.62c.3.77.48,1.15.48,1.15A11.25,11.25,0,0,1,198.71,107.86Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227,116.25l-26.84-4.9-1,1.32,15.35,11.65a2.1,2.1,0,0,1,2.69-.14,2.14,2.14,0,0,1-2.59,3.41A2.11,2.11,0,0,1,214,125l-15.35-11.64-.95,1.24,12.1,25.18c6.07-7.13,14.3-3,14.3-3l5-6.59C221.91,124.66,227,116.25,227,116.25Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.32,
    y: 132.03,
    width: 12.56,
    height: 7.77,
    transform: "translate(-17.46 236.66) rotate(-52.81)",
    style: {
      fill: "#5cffe4",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.24,
    y: 318.95,
    width: 55.38,
    height: 94.99,
    style: {
      stroke: "#39ff14",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,413.94s0-.16,0-.47,0-.77,0-1.35c0-1.21,0-3,0-5.24,0-4.58,0-11.23-.06-19.63,0-16.78-.07-40.49-.12-68.3l.24.24-55.37,0h0l.26-.26c0,36.24,0,69.47-.06,95l-.2-.2,40.37.11,11.1,0,2.9,0,1,0s-.32,0-1,0l-2.87,0-11.05.05-40.5.1H65v-.2c0-25.52,0-58.75-.06-95v-.26h.27l55.37,0h.24V319c0,27.87-.09,51.64-.12,68.46,0,8.37,0,15-.06,19.57,0,2.26,0,4,0,5.19,0,.58,0,1,0,1.33S120.62,413.94,120.62,413.94Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.24,
    y: 318.95,
    width: 55.38,
    height: 8,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.55 336.94 79.22 345.81 81.7 342.58 85.84 342.41 78.55 336.94",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.48,337a4.7,4.7,0,0,1,.53.36l1.51,1.08c1.3.94,3.18,2.29,5.34,3.9l.34.25-.42,0-4,.17h-.14l.12-.06-2.49,3.22-.24.31,0-.39c-.19-2.62-.32-4.88-.4-6.44,0-.7-.08-1.3-.1-1.82a4.76,4.76,0,0,1,0-.61,6.88,6.88,0,0,1,.08.7c0,.53.11,1.14.18,1.86.15,1.57.36,3.75.56,6.29l-.26-.08,2.47-3.23,0-.06h.22l4-.16-.09.27c-2.08-1.57-3.84-2.95-5.12-3.95l-1.51-1.18Z",
    style: {
      fill: "#39ff14",
      stroke: "#39ff14",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,375.53c-.06-.06,2.69-3,6.16-6.56s6.32-6.41,6.38-6.35-2.69,3-6.16,6.57S77,375.59,76.94,375.53Z",
    style: {
      fill: "#39ff14",
      stroke: "#39ff14",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,369a16.3,16.3,0,0,0-.31-2,8.23,8.23,0,0,0-2.89-4.46A7.75,7.75,0,0,0,101,364.24,8.23,8.23,0,0,0,99.5,369a8.31,8.31,0,0,0,1.49,4.75,7.92,7.92,0,0,0,3.66,2.86,7.69,7.69,0,0,0,7.54-1.17,8.21,8.21,0,0,0,2.89-4.47,16.34,16.34,0,0,0,.31-2,7,7,0,0,1-.19,2,8.22,8.22,0,0,1-2.87,4.61,7.9,7.9,0,0,1-7.79,1.26,8.1,8.1,0,0,1-3.8-2.95,8.54,8.54,0,0,1,0-9.84,8.12,8.12,0,0,1,3.8-3,7.9,7.9,0,0,1,4.35-.35,8,8,0,0,1,3.44,1.61A8.27,8.27,0,0,1,115.2,367,7,7,0,0,1,115.39,369Z",
    style: {
      fill: "#39ff14",
      stroke: "#39ff14",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,390.09s.07,0,.2.15l.58.47,2.18,1.88.07.06-.07.07-9.3,10.69,0,0h-.06l-1.12.17-2,.3-.21,0,0-.22.72-3.66v0l0,0c2.52-3,4.72-5.49,6.31-7.26a16.89,16.89,0,0,1,2.67-2.67,2.47,2.47,0,0,1-.18.18c-.12.12-.3.29-.51.53-.44.48-1.06,1.19-1.84,2.09-1.55,1.79-3.72,4.34-6.23,7.32l0-.07-.72,3.67-.17-.18,2-.31,1.12-.17-.09.05L111,392.59v.14L109,390.81l-.56-.52A1.82,1.82,0,0,1,108.21,390.09Z",
    style: {
      fill: "#39ff14",
      stroke: "#39ff14",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,403.05a1.61,1.61,0,0,1,0-.26l0-.73c0-.7,0-1.61,0-2.74,0-2.4,0-5.7-.07-9.64l.14.14-13,0,.16-.15h0v3.58c0,1.18,0,2.34,0,3.46,0,2.24,0,4.35,0,6.3l-.14-.14,9.37.07L87,403h.7l.26,0h-.23l-.68,0-2.62,0-9.46.07h-.13v-.13c0-1.95,0-4.06,0-6.3v-3.46c0-.59,0-1.18,0-1.78v-1.8h0c-.14.13.19-.2.16-.16l13,0h.13v.13c0,4,0,7.3-.07,9.73q0,1.66,0,2.7l0,.71A2.07,2.07,0,0,1,88,403.05Z",
    style: {
      fill: "#39ff14",
      stroke: "#39ff14",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,389.68a12.43,12.43,0,0,1-2.82.16,12.38,12.38,0,0,1-2.81-.16,13.54,13.54,0,0,1,2.81-.15A13.6,13.6,0,0,1,76.94,389.68Z",
    style: {
      fill: "#39ff14",
      stroke: "#39ff14",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,392.25a31.38,31.38,0,0,1,0-6.33,31.38,31.38,0,0,1,0,6.33Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.16,
    y: 180.68,
    width: 31.8,
    height: 36.73,
    rx: 11.43,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.66,194.39h3.18c1.79,0,3.26.65,3.26,3s-1.37,3-3.17,3h-1.38v3.86h-1.89Zm1.89,4.19h1.26c.66,0,1.33-.26,1.33-1.19s-.9-1.16-1.62-1.16h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.29,194.39h1.89v3.69h3.67v-3.69h1.89v9.9h-1.89V200h-3.67v4.28h-1.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.49,194.39h3.18c1.78,0,3.26.65,3.26,3s-1.37,3-3.17,3h-1.38v3.86h-1.89Zm1.89,4.19h1.26c.66,0,1.33-.26,1.33-1.19s-.9-1.16-1.63-1.16h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.47,
    y: 208.86,
    width: 41.84,
    height: 41.84,
    rx: 8.1,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.89,225.1h1.94v3.27h3.75V225.1h1.93v8.77h-1.93v-3.79h-3.75v3.79h-1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678,226.81h-2.5V225.1h6.94v1.71h-2.5v7.06H678Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.41,225.1h2.92l2,5.72h0l2-5.72h2.91v8.77h-1.93v-6.73h0l-2.3,6.73h-1.48l-2.21-6.73h0v6.73h-1.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.18,225.1h1.93v7h3.58v1.79h-5.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.72,
    y: 88.16,
    width: 59.02,
    height: 59.02,
    rx: 11.43,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.51,119.26c0,2.23-.58,4.34-3.84,4.34a3.38,3.38,0,0,1-3.69-2.81l2.43-.59a1.23,1.23,0,0,0,1.19,1c1.24,0,1.26-1.37,1.26-2.27v-7.72h2.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.75,111.26h2.19l5.24,12h-3l-1-2.55h-4.67l-1,2.55h-2.92Zm1,3.5-1.46,3.74h2.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.15,111.26h3l3,7.89h0l3-7.89h2.84l-5,12H564Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.21,111.26h2.2l5.23,12h-3l-1-2.55h-4.67l-1,2.55H570Zm1,3.5-1.46,3.74h2.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.54,
    y: 225.48,
    width: 43.61,
    height: 43.61,
    rx: 8.44,
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.45,249.06c0,3.12-.81,6.08-5.39,6.08-2.68,0-4.63-1.24-5.18-3.94l3.41-.83a1.74,1.74,0,0,0,1.67,1.48c1.74,0,1.77-1.94,1.77-3.2V237.81h3.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,241.94a3.62,3.62,0,0,0-2.7-1.12c-1,0-2.5.48-2.5,1.74,0,3.08,7.77,1.1,7.77,7,0,3.77-3,5.56-6.51,5.56a8,8,0,0,1-5.68-2.12l2.65-2.91a4.12,4.12,0,0,0,3.24,1.59c1.22,0,2.58-.57,2.58-1.76,0-3.1-7.92-1.43-7.92-7.07,0-3.6,3.13-5.48,6.44-5.48a7.66,7.66,0,0,1,5.18,1.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-arm-colors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.2,373.27s-10.49,48,6.94,58.73c4.28,2.63,10.26,3,18.49-.16,7.14,37.72-17.28,77.12-17.28,77.12l-13.63,0-25.95,0c-12-56.86,4.58-69.12,4.58-69.12-4-21.43,6.85-28.57,6.85-28.57-6-8.29-1.28-37.71-1.28-37.71Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,431.84s21.14-8.28,14.14-58.28l-39.57-.29S227.63,447.7,269.63,431.84Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,411.27s5.72,4.57,6.72-13.29",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.06,421s-21.43,21.43-15.43,54",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,432a32.79,32.79,0,0,1,4.54,12.69,31.48,31.48,0,0,1-.05,9.44",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.68,444.69s1.52-9.9,5.81-10.76",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,508.91s14.25-7,16.61-36.14",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,384.06l-2.13,9.66-1.06,7.67a26.78,26.78,0,0,1-2,4.82c-.92,1.48-1.32.51-1.48-1.37-.23-2.57,0-6.79,0-8.62,0-3.54.24-7.64.67-12.4Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.24,416.07a8.53,8.53,0,0,1-1.34,6.5c-6.05,8.64-17,28.19-12.86,52.43a6.65,6.65,0,0,1-.08,2.63l-3.22,13.09-1.51,3.13a1.94,1.94,0,0,1-3.67-.55c-1.51-10.1-2.53-22.55-1.48-32.65.81-7.68,2.83-14,6.76-16.85l2.18-1.59-.38-2.68c-.65-4.68,3.25-23,9.32-24.87l1.87-4.15,3.44-7.65.55,7.47Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.08,443c1,31.43-14.6,57.66-17.36,62.05l-8.52-.56H244a.6.6,0,0,0,.12-.11l.21-.17a2.83,2.83,0,0,0,.43-.36l.42-.37c.2-.18.39-.38.58-.57s.52-.54.77-.84.41-.48.62-.74.4-.51.58-.77.37-.5.54-.75.4-.61.59-.92.39-.63.55-.95a49,49,0,0,0,4.84-13.35c0-.2.09-.42.14-.63.09-.45.19-.9.27-1.33s.14-.74.2-1.08c.11-.59.2-1.15.29-1.7s.15-1,.21-1.45c.11-.79.2-1.49.26-2.12,0-.2,0-.38.07-.54s0-.13,0-.18,0-.35.05-.51c.09-.93.12-1.54.13-1.68l0-.64-1.26-.07h0L256,455.13l1.11.23.13-.63a27.17,27.17,0,0,0,.16-9.28,2.35,2.35,0,0,0-.05-.37V445h0a20.53,20.53,0,0,1,1.2-4.44c.17-.46.33-.94.53-1.41a4.52,4.52,0,0,1,.18-.47c.45-1.15.93-2.34,1.42-3.43h.16c.4,0,.79,0,1.18,0s1-.05,1.5-.1l1.07-.14c.4-.05.77-.12,1.13-.19l.53-.11a9.76,9.76,0,0,0,1-.23,2.21,2.21,0,0,0,.46-.11l.45-.12.79-.23.38-.13h0c.22,1.55.39,3.08.52,4.61.07.9.14,1.8.18,2.69a2.62,2.62,0,0,1,0,.29C270.05,442,270.07,442.46,270.08,443Z",
    style: {
      fill: "#f4a995"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-arm-lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.2,373.27s-10.49,48,6.94,58.73c4.28,2.63,10.26,3,18.49-.16,7.14,37.72-17.29,77.1-17.29,77.1H238.61l-25.86,0c-12-56.86,4.6-69.12,4.6-69.12-4-21.43,6.85-28.57,6.85-28.57-6-8.29-1.28-37.71-1.28-37.71Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,431.84s21.14-8.28,14.14-58.28l-39.57-.29S227.63,447.7,269.63,431.84Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,411.27s5.72,4.57,6.72-13.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.06,421s-21.43,21.43-15.43,54",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,432a32.79,32.79,0,0,1,4.54,12.69,31.48,31.48,0,0,1-.05,9.44",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.68,444.69s1.52-9.9,5.81-10.76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,508.91s14.25-7,16.61-36.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-arm-colors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.49,437.84C470.63,468.7,490.4,509,490.4,509l20.68,0h27.8c12-56.86-3.82-66.54-3.82-66.54,4-21.43-6.57-24.28-6.57-24.28,6-8.29-2.32-38.36-2.32-38.36",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.35,418.13c-3.84-.76-6.22-4.72-4.72-16.57",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.63,424.7s13.92,13,7.92,45.57",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92,438.27s-3.43,6.14-3.29,11.57c.08,2.87.43,3.57,2.86,11",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.49,449.7s-3.14-8.43-10.72-9.29",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.2,505.56s-6.32,3.75-8.68-25.4",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.26,438.7s-21.15-8.29-14.15-58.29l45.81-.43S525.92,454.13,479.26,438.7Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.16 379.78 510.92 379.98 511.35 396.38 527.31 394.66 526.16 379.78",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.79,398.7h.13c.29,6.05.93,12.23-1.1,16.22-.86-1.71-.86-4.15-.86-6.43l-1.61-13.36C524.41,394.79,527.61,398.64,527.79,398.7Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.26,446.34c6.23,6.46,6.41,33.83,3.88,59.55a1.25,1.25,0,0,1-2.42.27l-6.26-18.72a8.93,8.93,0,0,1-.33-4.29l.28-1.62c2.79-16.38,2.14-28.09.23-36.31l2.78-.79Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.05,425.58c4.61,7.53,2.16,16.26,2.13,16.35l-.76,2.5-2.78.79A37.52,37.52,0,0,0,519,431.9a4.3,4.3,0,0,1-.63-3.68l-2-9.38,2.28-19.57C518.63,420.66,526.49,424.08,526.05,425.58Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.92,504.7c-10.61-16.17-12.4-23.3-14.4-40,0-.23-.06-.47-.08-.71-.05-.42-.09-.84-.13-1.24l-.07-.58c0-.38-.06-.75-.08-1.11l-.1-1.36a6.13,6.13,0,0,1,0-.62,4.16,4.16,0,0,1,0-.54c0-.26,0-.52-.05-.79v-.34c-.05-1.2-.07-2.34-.06-3.46,0-1,0-1.88.05-2.78l0-.76v-.14c0-.61.06-1.19.1-1.76,0-.26.05-.52.06-.77l0-.45c0-.33.07-.66.1-1l0-.39c0-.15,0-.31.06-.5.15-1.25.33-2.45.53-3.57.08-.46.16-.87.24-1.24.05-.21.1-.41.13-.57l0-.05.58.16a38,38,0,0,0,4.75.88l.66.08h0a5.17,5.17,0,0,1,.63.21h0a36.33,36.33,0,0,1,5,5.63c.24.34.44.7.65,1a6.44,6.44,0,0,1,1,2.83l.06.51v.13h0c0,.4,0,.8.05,1.18s.05.8.09,1.2.07.8.12,1.2a36.68,36.68,0,0,0,.75,4.33c.17.73.34,1.43.54,2.15.3,1.07.64,2.14,1,3.24l.2.61.05,0L500,484.8l-.67.05.05.64a37.37,37.37,0,0,0,.82,5.37l.12.67c.06.22.11.47.18.7s.11.48.17.73c.19.73.4,1.51.64,2.3.08.26.16.52.23.78a48.71,48.71,0,0,0,2,5.15l.41.86c1.15,2.37,2.55,5.89,2.8,6.15S492.92,504.7,492.92,504.7Z",
    style: {
      fill: "#f4a995"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-arm-lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.49,437.84C470.63,468.7,490.43,509,490.43,509h48.42c12-56.86-3.79-66.54-3.79-66.54,4-21.43-6.57-24.28-6.57-24.28,6-8.29-2.32-38.36-2.32-38.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.35,418.13c-3.84-.76-6.93-4.72-5.86-16.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.63,424.7s13.92,13,7.92,45.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92,438.27s-3.43,6.14-3.29,11.57c.08,2.87.43,3.57,2.86,11",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.49,449.7s-3.12-8.31-10.69-9.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.46,509s-5.72-3.4-7.22-24.94",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.26,438.7s-21.15-8.29-14.15-58.29l45.81-.43S525.92,454.13,479.26,438.7Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510.92,
    y1: 379.98,
    x2: 526.2,
    y2: 380.13,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "neck-colors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.2,300.41c-36.85-2.57-34.43-47.28-34.43-47.28m34.43,47.28s33.72,1.15,27.27-47.28h0s-31.84,16.43-61.7,0",
    style: {
      fill: "#f4a995"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.49,266.37s30.41,5.76,45.09-.53c0,0,2.1,23.33-20.45,27.53C379.13,293.37,355.54,291.53,354.49,266.37Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "neck-lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.43,276.38s4.83,6.26,9.54-.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,253.13c30.43,15.85,61.7,0,61.7,0h0c1.55,7,.45,10.43.45,10.43-2.32.82-4.55,1.56-6.71,2.2-41.14,12.25-55.58-7.35-55.58-7.35l.14-5.28m55.44,12.63s2,25.42-20.08,27.61l-.93,7s28.29-.28,27.72-36.85",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "body-color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body",
    d: "M299.09,509l148.83-.07.41-104s14.16-1.28,16.73-24.43l61.14-.28S525,359.41,519.47,353c0,0,12-63.85-57.86-72.42,0,0-31.71-27-56.14-27.43,6.41,47.28-28.7,47.28-28.7,47.28-36-4.57-33-47.28-33-47.28-24.42.43-56.14,27.43-56.14,27.43C217.77,289.13,229.77,353,229.77,353c-5.57,6.43-6.85,20.58-6.85,20.58h60.85c2.58,23.14,17.15,31.28,17.15,31.28l-1.83,104.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "body-lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body-2",
    "data-name": "body",
    d: "M299.09,509l148.83-.07.41-104s14.16-1.28,16.73-24.43l61.14-.28S525,359.41,519.47,353c0,0,12-63.85-57.86-72.42,0,0-31.71-27-56.14-27.43,6.41,47.28-28.7,47.28-28.7,47.28-36-4.57-33-47.28-33-47.28-24.42.43-56.14,27.43-56.14,27.43C217.77,289.13,229.77,353,229.77,353c-5.57,6.43-6.85,20.58-6.85,20.58h60.85c2.58,23.14,17.15,31.28,17.15,31.28l-1.83,104.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), _ref3, /*#__PURE__*/React.createElement("g", {
    id: "face-colors"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jaw",
    d: "M438.35,176l.28,12.43c0,44.38-22.66,72-67,72,0,0-62.09.06-58-69.85l.25-15.11,10.18-56.89,101.57-1.29Z",
    style: {
      fill: "#f4a995"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.63,169l11.86,1.43s4,52.15-16.86,70.43Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.06,260.41h0c-21.86,0-28.29-23.14-28.29-45V101.84l76.29,22.86.86,92.71C430.77,239.84,408.2,257.56,381.06,260.41Z",
    style: {
      fill: "#e28a6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,107.84H412.2a0,0,0,0,1,0,0V223.41A37.57,37.57,0,0,1,374.63,261h0a39.57,39.57,0,0,1-39.57-39.57V107.84A0,0,0,0,1,335.06,107.84Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "M438.92,176l-.43-40.71c15.43-29.14-11.14-25.71-11.14-25.71-1.72-21-18.7-10.42-18.7-10.42-2.95-21.08-20.73-11.66-20.73-11.66C377,64.56,362.2,86.41,362.2,86.41c-19.71-10.71-21,9-21,9-19.71-7.71-18.43,12.86-18.43,12.86-24.42,0-9.42,28.71-9.42,28.71v38.58c9,0,9-4.29,9-4.29V153.06a23.85,23.85,0,0,1,23.78-23.79h59.14a24.29,24.29,0,0,1,24.22,24.21v17.36A8.12,8.12,0,0,0,438.92,176Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-ear",
    d: "M438.27,167.84c8.11,0,12.65,6.14,12.65,14.25s-4.54,14-12.65,14",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-ear",
    d: "M313.7,168.52c-8.1,0-12.64,6.14-12.64,14.25s4.54,14,12.64,14",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    d: "M373.92,190.7l-1.43,10.57s-14.57,6.29-.29,12.29",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.06,229h27.71s4.06.34,8.49-4.09",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.06,218.41s10.57,2,8,9.15",
    style: {
      fill: "#ed9677"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 405.7,
    cy: 176.41,
    r: 6.57,
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,161.7a16.14,16.14,0,1,1-25.81,12.93,16.39,16.39,0,0,1,.49-4,16.22,16.22,0,0,1,5.53-8.59",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.13,174.66a16.39,16.39,0,1,1-32.78,0c0-1.54,1.43-5.67.61-4.45,0,.06,31.67.42,31.69.48A16.79,16.79,0,0,1,422.13,174.66Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-left",
    d: "M422.85,174.66a16.4,16.4,0,1,1-32.79,0c0-1.54,1.44-5.67.61-4.45,0,.06,31.68.42,31.69.48A16.79,16.79,0,0,1,422.85,174.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 343.85,
    cy: 177.2,
    r: 6.57,
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,162.48a16.15,16.15,0,1,1-25.81,12.93,16.31,16.31,0,0,1,.5-4,16.09,16.09,0,0,1,5.53-8.59",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-right",
    d: "M361.27,175.23a16.39,16.39,0,1,1-32.78,0c0-1.54,1.43-5.67.61-4.45,0,.06,31.67.42,31.69.49A16.71,16.71,0,0,1,361.27,175.23Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "face-lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jaw-2",
    "data-name": "jaw",
    d: "M438.35,176l.28,12.43c0,44.38-22.66,72-67,72,0,0-62.09.06-58-69.85l.25-15.11",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair-2",
    "data-name": "hair",
    d: "M438.92,176l-.43-40.71c15.43-29.14-11.14-25.71-11.14-25.71-1.72-21-18.7-10.42-18.7-10.42-2.95-21.08-20.73-11.66-20.73-11.66C377,64.56,362.2,86.41,362.2,86.41c-19.71-10.71-21,9-21,9-19.71-7.71-18.43,12.86-18.43,12.86-24.42,0-9.42,28.71-9.42,28.71v38.58c9,0,9-4.29,9-4.29V153.06a23.85,23.85,0,0,1,23.78-23.79h59.14a24.29,24.29,0,0,1,24.22,24.21v17.36A8.12,8.12,0,0,0,438.92,176Z",
    style: {
      fill: "#1e1e1e",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-ear-2",
    "data-name": "right-ear",
    d: "M438.27,167.84c8.11,0,12.65,6.14,12.65,14.25s-4.54,14-12.65,14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-ear-2",
    "data-name": "left-ear",
    d: "M313.7,168.52c-8.1,0-12.64,6.14-12.64,14.25s4.54,14,12.64,14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-eye-2",
    "data-name": "left-eye"
  }, _ref4, /*#__PURE__*/React.createElement("line", {
    x1: 329.27,
    y1: 171.43,
    x2: 360.2,
    y2: 171.43,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,162.48a16.15,16.15,0,1,1-25.81,12.93,16.31,16.31,0,0,1,.5-4,16.09,16.09,0,0,1,5.53-8.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-eye-2",
    "data-name": "right-eye"
  }, _ref5, /*#__PURE__*/React.createElement("line", {
    x1: 390.05,
    y1: 170.64,
    x2: 421.2,
    y2: 170.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,161.7a16.14,16.14,0,1,1-25.81,12.93,16.39,16.39,0,0,1,.49-4,16.22,16.22,0,0,1,5.53-8.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "nose-2",
    "data-name": "nose",
    d: "M373.92,190.7l-1.43,10.57s-14.57,6.29-.29,12.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "mouth-2",
    "data-name": "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.06,229h27.71s4.06.34,8.49-4.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.06,218.41s10.57,2,8,9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.26,
    y: 489.54,
    width: 336.49,
    height: 23.83,
    rx: 7.07,
    style: {
      fill: "#c58fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "laptop-light",
    points: "236.69 490.79 78.04 123.73 672.89 123.73 511.08 490.79 236.69 490.79",
    style: {
      opacity: 0.34,
      fill: "url(#Degradado_sin_nombre_48)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.69,
    y: 335.48,
    width: 287.71,
    height: 177.9,
    rx: 9.07,
    style: {
      fill: "#c58fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _ref6, /*#__PURE__*/React.createElement("path", {
    d: "M346.63,424.58a2.85,2.85,0,0,1-1.48-1.62,3.19,3.19,0,0,1,0-2.39,3.31,3.31,0,0,1,1.92-1.87l14-5.61c.46-.19.94,0,1.45.61a3.12,3.12,0,0,1,.8,1.93,1.7,1.7,0,0,1-.94,1.61l-11.69,4.55,11.72,4.72a1.7,1.7,0,0,1,.74,1.53,3.32,3.32,0,0,1-.67,1.93c-.45.6-.9.81-1.36.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,430A3.26,3.26,0,0,1,383,428a1.72,1.72,0,0,1,.74-1.53l11.72-4.72-11.68-4.55a1.71,1.71,0,0,1-1-1.61,3.12,3.12,0,0,1,.8-1.93c.51-.6,1-.8,1.46-.61l14,5.61a3.57,3.57,0,0,1,1.64,1.35,3,3,0,0,1,.53,1.74,3.49,3.49,0,0,1-.47,1.66,2.63,2.63,0,0,1-1.23,1.13l-14.49,6C384.52,430.78,384.07,430.57,383.63,430Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,442.64a1.28,1.28,0,0,1-1.75.4,1.26,1.26,0,0,1-.64-1.67l1.57-3,2.41,1.27Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.83,401.24l.94-1.77s.34-.8.8-.55,0,1,0,1l-.94,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.59,399.49a7.77,7.77,0,0,1-1.78,1.78,12,12,0,0,1-2.45,1.55l.1.9,3.81,2,.93-.35a10.38,10.38,0,0,1-.07-3,11.66,11.66,0,0,1,.49-2.39Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.21,405.38s-3.8,6.1-4.81,7.92C372,426.72,363.46,442,363.46,442l-3-1.6s8.15-15.61,15-29.06c1.4-2.73,3.87-8.5,3.87-8.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.94,
    y: 437.41,
    width: 2.19,
    height: 3.55,
    transform: "translate(-195.45 552.21) rotate(-61.86)",
    style: {
      fill: "#24262b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.44,
    y: 411.16,
    width: 6.33,
    height: 1.52,
    rx: 0.33,
    transform: "translate(-163.7 550.65) rotate(-61.86)",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.62,
    y: 410.43,
    width: 0.75,
    height: 1.52,
    transform: "translate(-162.8 550.83) rotate(-61.89)",
    style: {
      fill: "#161719"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "glasses"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.73 196.43 318.22 180.48 322.13 160.06 338.62 161.3 324.73 196.43",
    style: {
      fill: "#22890c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.39 200.74 324.5 195.78 338.81 159.21 358.49 161.08 342.39 200.74",
    style: {
      fill: "#38cc19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.58 197.5 341.93 199.88 357 161.78 371.78 167.63 359.58 197.5",
    style: {
      fill: "#39ff14"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 317,
    cy: 165.46,
    rx: 3.74,
    ry: 1.19,
    style: {
      fill: "#5cffe4"
    }
  }), _ref7, /*#__PURE__*/React.createElement("path", {
    d: "M428.54,165.24c-4.33-3-15.23-3.22-22.45-2.78-5.44.34-17.22,1.78-19.44,6S387.73,185,390,189.24c2.78,5.23,7.45,7.89,14.45,8.78s15.37-.48,19.59-3c3.72-2.21,5.52-9.22,6.41-13.44S432.88,168.24,428.54,165.24Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.95,
    cy: 165.46,
    rx: 3.74,
    ry: 1.19,
    style: {
      fill: "#5cffe4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,169.36h-2.42a.6.6,0,1,1,0-1.2h2.42a.6.6,0,0,1,0,1.2Zm.59,2.17a.59.59,0,0,0-.59-.6h-2.42a.6.6,0,0,0-.6.6.59.59,0,0,0,.6.59h2.42A.58.58,0,0,0,396.89,171.53Zm0,2.76a.58.58,0,0,0-.59-.59h-2.42a.59.59,0,0,0-.6.59.6.6,0,0,0,.6.6h2.42A.59.59,0,0,0,396.89,174.29Zm0,2.77a.59.59,0,0,0-.59-.6h-2.42a.6.6,0,0,0,0,1.2h2.42A.59.59,0,0,0,396.89,177.06Zm0,2.77a.59.59,0,0,0-.59-.6h-2.42a.6.6,0,0,0-.6.6.59.59,0,0,0,.6.59h2.42A.58.58,0,0,0,396.89,179.83Zm0,2.76a.58.58,0,0,0-.59-.59h-2.42a.59.59,0,0,0-.6.59.6.6,0,0,0,.6.6h2.42A.59.59,0,0,0,396.89,182.59Zm0,2.77a.59.59,0,0,0-.59-.6h-2.42a.6.6,0,0,0,0,1.2h2.42A.59.59,0,0,0,396.89,185.36Zm0,2.77a.59.59,0,0,0-.59-.6h-2.42a.6.6,0,0,0,0,1.2h2.42A.59.59,0,0,0,396.89,188.13ZM406,168.76a.6.6,0,0,0-.6-.6H399a.6.6,0,1,0,0,1.2h6.35A.6.6,0,0,0,406,168.76Zm0,2.77a.6.6,0,0,0-.6-.6H399a.6.6,0,0,0-.6.6.59.59,0,0,0,.6.59h6.35A.59.59,0,0,0,406,171.53Zm0,2.76a.59.59,0,0,0-.6-.59H399a.59.59,0,0,0-.6.59.6.6,0,0,0,.6.6h6.35A.6.6,0,0,0,406,174.29Zm0,2.77a.6.6,0,0,0-.6-.6H399a.6.6,0,0,0,0,1.2h6.35A.6.6,0,0,0,406,177.06Zm0,2.77a.6.6,0,0,0-.6-.6H399a.6.6,0,0,0-.6.6.59.59,0,0,0,.6.59h6.35A.59.59,0,0,0,406,179.83Zm7.61,2.76a.59.59,0,0,0-.6-.59h-6.35a.59.59,0,0,0-.6.59.6.6,0,0,0,.6.6H413A.6.6,0,0,0,413.56,182.59Zm0,2.77a.6.6,0,0,0-.6-.6h-6.35a.6.6,0,0,0,0,1.2H413A.6.6,0,0,0,413.56,185.36Zm0,2.77a.6.6,0,0,0-.6-.6h-6.35a.6.6,0,0,0,0,1.2H413A.6.6,0,0,0,413.56,188.13Zm-4.81-19.37a.7.7,0,1,0-.69.69A.69.69,0,0,0,408.75,168.76Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,410.82,168.76Zm2.08,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,412.9,168.76Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,415,168.76Zm2.08,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,417.05,168.76Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,419.12,168.76Zm-10.37,5.53a.7.7,0,1,0-.69.7A.69.69,0,0,0,408.75,174.29Zm2.07,0a.69.69,0,1,0-.69.7A.69.69,0,0,0,410.82,174.29Zm2.08,0a.69.69,0,1,0-.69.7A.69.69,0,0,0,412.9,174.29Zm2.07,0a.69.69,0,1,0-.69.7A.69.69,0,0,0,415,174.29Zm2.08,0a.69.69,0,1,0-.69.7A.69.69,0,0,0,417.05,174.29Zm2.07,0a.69.69,0,1,0-.69.7A.69.69,0,0,0,419.12,174.29Zm-3.28,8a.7.7,0,1,0-.69.69A.69.69,0,0,0,415.84,182.25Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,417.91,182.25Zm2.08,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,420,182.25Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,422.06,182.25Zm2.08,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,424.14,182.25Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,426.21,182.25ZM415.84,188a.7.7,0,1,0-.69.69A.69.69,0,0,0,415.84,188Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,417.91,188Zm2.08,0a.69.69,0,1,0-1.38,0,.69.69,0,0,0,1.38,0Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,422.06,188Zm2.08,0a.69.69,0,1,0-1.38,0,.69.69,0,1,0,1.38,0Zm2.07,0a.69.69,0,1,0-.69.69A.69.69,0,0,0,426.21,188Z",
    style: {
      fill: "#1a2e35"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.5658574f.svg";
export { ForwardRef as ReactComponent };